import { HeartIcon as SolidHeartIcon } from "@heroicons/react/24/solid";
import { MagnifyingGlassCircleIcon } from "@heroicons/react/24/solid";
import { Link, useLocation } from "react-router-dom";
import ci from "../../assets/images/kbg_ci.png";

export default function Header() {
  const location = useLocation();
  return (
    <div className="flex justify-between items-center mb-8 py-2 md:px-20 h-16">
      {/* <div className="flex-1 p-4 bg-red-200">Item 1</div>
      <div className="flex-2 p-4 bg-green-200">Item 2</div>
      <div className="flex-1 p-4 bg-blue-200">Item 3</div> */}
      <Link
        to={`/opening-warehouse${location.search}`}
        className="inline-flex h-[50px] w-[50px] shrink-0 items-center justify-center text-xs text-slate-500"
        aria-label="홈"
      >
        <img
          src={ci}
          alt="home"
          width="50"
          height="50"
          style={{ pointerEvents: "none" }}
        />
      </Link>
      <div className="w-3/5 md:w-9/12">
        <Link to={`/opening-warehouse/search-product${location.search}`}>
          <div className="flex justify-center items-center text-gray-700 rounded border-gray-500 bg-slate-200 h-10">
            <MagnifyingGlassCircleIcon className="w-8 ml-4" />
            <span className="font-bold p-1 mr-4">상품 검색</span>
          </div>
        </Link>
      </div>
      <Link to={`/opening-warehouse/like-product${location.search}`}>
        <SolidHeartIcon className="h-10 w-10 text-red-500" />
      </Link>
    </div>
  );
}
